import { Component, inject } from '@angular/core';
import { ListOfContractsComponent } from '../../components/list-of-contracts/list-of-contracts.component';
import { AccountService } from '../../services/account.service';
import { ContractDetails } from '../../models/contract-details';
import { Observable } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { Contracts } from '../../models/contracts';
import { Router } from '@angular/router';

@Component({
    selector: 'app-contract-list-container',
    imports: [ListOfContractsComponent],
    templateUrl: './contract-list-container.component.html',
    styleUrl: './contract-list-container.component.scss',
})
export class ContractListContainerComponent {
    private readonly contractList$: Observable<ContractDetails[]> =
        this.accountService.getListOfContracts();

    public readonly signalContractList = toSignal(this.contractList$);

    private readonly router = inject(Router);

    constructor(private readonly accountService: AccountService) {
        this.accountService.getBusinessProfile().subscribe((res) => {});
    }

    getEvents(contract: Contracts) {
        this.router.navigate(
            ['/dashboard/contract-events', contract.contractUUID],
            {
                state: {
                    contractData: contract, // or any other data you want to send
                },
            }
        );
    }
}
